export default __webpack_public_path__ + "static/media/img-slider-craft-2024-5.c7717c58.png";